<template>
  <div class="row">
    <div class="col-md-3">
      <form class="needs-validation" ref="form" id="form">
        <div class="form-group">
          <label class="mb-0" for="Operator">Operator: </label>
          <select class="form-control" v-model="operator" required>
            <option
              v-for="operator in operators"
              :key="operator.id"
              :value="operator.id"
            >
              {{ operator.username }}
            </option>
          </select>
        </div>

        <div class="mb-1 form-group">
          <label class="mb-0" for="GlassBatch">Cell Batch: </label>
          <input
            type="text"
            class="form-control"
            v-model="cellBatch"
            id="CellBatch"
            required
          />
        </div>

        <div class="mb-1 form-label">
          <label class="form-check-label">Cell Typ</label>
        </div>

        <div class="mb-1 form-check">
          <input
            class="form-check-input"
            type="radio"
            name="cellType"
            id="radio1"
            value="22.4%-2 D"
            v-model="cellType"
          />
          <label class="from-check-label" for="radio1"> 22.4%-2 D </label>
        </div>
        <div class="mb-1 form-check">
          <input
            class="form-check-input"
            type="radio"
            name="cellType"
            id="radio2"
            value="22.4%-1 D"
            v-model="cellType"
          />
          <label class="from-check-label" for="radio2"> 22.4%-1 D </label>
        </div>

        <button type="button" class="btn btn-primary mb-3" @click="submit()">
          Speichern
        </button>
      </form>

      <transition name="alert">
        <div
          class="alert alert-success mt-1"
          role="alert"
          v-if="triggerSuccess"
        >
          Der Eintrag wurde gespeichert!
        </div>
      </transition>

      <transition name="alert">
        <div class="alert alert-danger mt-1" role="alert" v-if="triggerError">
          Eintrag konnte nicht gespeichert werden!
        </div>
      </transition>

      <transition name="alert">
        <div
          class="alert alert-warning mt-1"
          role="alert"
          v-if="triggerWarning"
        >
          Bitte füllen Sie alle Felder aus!
        </div>
      </transition>
    </div>

    <div class="col-md-9">
      <CellTable :url="props.tableUrl" :key="componentKey" />
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, defineProps, watch } from "vue";
import CellTable from "@/components/cell/CellTable.vue";
import { instance as axios } from "@/services/axios";

const props = defineProps({
  stationId: {
    type: Number,
    required: true,
  },
  tableUrl: {
    type: String,
    required: true,
  },
});

const componentKey = ref(0);
let operator = ref();
let cellBatch = ref();
let cellType = ref();

const operators = ref([]);

let triggerSuccess = ref(false);
let triggerError = ref(false);
let triggerWarning = ref(false);

onMounted(async () => {
  try {
    const { data } = await axios.get("/User/GetUsersByJobtype/2");
    operators.value = data
      .map(({ id, username }) => ({ id, username }))
      .sort((a, b) => a.username.localeCompare(b.username));
  } catch (error) {
    console.error("Erro ao carregar operadores:", error);
  }
});

watch(cellBatch, (newValue) => {
  if (newValue && newValue.includes("$")) {
    cellBatch.value = newValue.slice(newValue.indexOf("$") + 1);
  }
});
document.addEventListener("keydown", (event) => {
  if (event.key === "$") {
    cellBatch.value = "";
  }
});

function resetForm() {
  operator.value = null;
  cellBatch.value = null;
  componentKey.value = 1;
  cellType.value = null;
}

async function submit() {
  //checks form validity, because standard form validation doesn't work due to incompatibilities of bootstrap/vue3
  if (
    !document.getElementById("form").checkValidity() ||
    cellType.value == null
  ) {
    //warning alert
    triggerWarning.value = true;
    setTimeout(() => (triggerWarning.value = false), 5000);
    return;
  }

  const currentDate = new Date().toISOString();

  const jsonObject = {
    operatorid: operator.value,
    stationid: props.stationId,
    dateInProduction: currentDate,
    cellBatch: cellBatch.value,
    cellType: cellType.value,
  };

  try {
    await axios.post("/Material/AddMaterialcell", jsonObject);
    triggerSuccess.value = true;
  } catch (e) {
    console.log(e.message);

    triggerError.value = true;
    setTimeout(() => (triggerError.value = false), 5000);
    resetForm();
    return;
  }
  //success alert
  triggerSuccess.value = true;
  setTimeout(() => (triggerSuccess.value = false), 5000);
  resetForm();
}
</script>

<style>
.alert-enter-active,
.alert-leave-active,
.modal-enter-active {
  transition: opacity 0.5s ease;
}
.alert-enter-from,
.alert-leave-to,
.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

input[type="radio"] {
  transform: scale(1.3);
}
input[type="checkbox"] {
  transform: scale(1.2);
}
</style>
